import React from 'react';
import classNames from 'classnames';

import styles from './Onboarding.module.scss';

const RADIUS = 15;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;

/**
 * A circular progress indicator. Decorative; callers state the progress in text.
 */
export default function ProgressRing({ done, total, size = 36, inverse }) {
  const filled = total > 0 ? (CIRCUMFERENCE * done) / total : 0;

  return (
    <svg
      className={classNames(styles.ring, { [styles['ring-inverse']]: inverse })}
      width={size}
      height={size}
      viewBox="0 0 36 36"
      aria-hidden="true"
    >
      <circle className={styles['ring-track']} cx="18" cy="18" r={RADIUS} />
      <circle
        className={styles['ring-fill']}
        cx="18"
        cy="18"
        r={RADIUS}
        strokeDasharray={`${filled} ${CIRCUMFERENCE}`}
      />
    </svg>
  );
}
